import {
  ProductToOptionGroupLinkRecord,
  productToOptionGroupLinkFromJSON,
} from "common/records/ProductToOptionGroupLink";
import { Map, Record } from "immutable";
import { RootActions, RootState } from "common/reducers";
import { receive, reset } from "common/reducers/Utils";
import { IdType } from "common/types";
import {
  RECEIVE_PRODUCT_TO_OPTION_GROUP_LINK,
  RESET_PRODUCT_TO_OPTION_GROUP_LINK,
} from "common/reducers/productToOptionGroupLink.actions";

export const ProductToOptionGroupLinkStateRecord = Record({
  byId: Map<IdType, ProductToOptionGroupLinkRecord>(),
  lastSavedById: Map<IdType, ProductToOptionGroupLinkRecord>(),
});

export const initialState = ProductToOptionGroupLinkStateRecord();
export type ProductToOptionGroupLinkState = typeof initialState;

export const reducer = (state: RootState, action: RootActions): RootState => {
  switch (action.type) {
    case RECEIVE_PRODUCT_TO_OPTION_GROUP_LINK:
      const ptog = productToOptionGroupLinkFromJSON({ ...action.payload });

      return receive(state, "productToOptionGroupLinks", ptog) as RootState;

    case RESET_PRODUCT_TO_OPTION_GROUP_LINK:
      return reset(state, "productToOptionGroupLinks", action.payload.productToOptionGroupLinkId) as RootState;

    default:
      return state;
  }
};
